


















import {
  Component, Watch, Vue, Prop,
} from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { VFBLoginScope } from 'vue-facebook-login-component';
import DpButton from '@/components/atoms/DpButton/index.vue';
// eslint-disable-next-line import/extensions
import { Facebook } from '@/modules/auth/types/SocialAuthProviders/Facebook';
import DpDialog from '../../molecules/DpDialog/index.vue';
import DpUnderlinedLink from '../../molecules/DpUnderlinedLink/index.vue';

@Component({
  name: 'SocialAuth',
  components: {
    // VFacebookLogin,
    VFBLoginScope,
    DpButton,
    DpDialog,
    DpUnderlinedLink,
  },
})
export default class SocialAuth extends Vue {
  @Action('SOCIAL_LOGIN', { namespace: 'auth' }) protected dispatchSocialLogin: any;

  @Action('FACEBOOK_LOGIN', { namespace: 'auth' }) protected dispatchFacebookLogin: any;

  @Action('FACEBOOK_LOGOUT', { namespace: 'auth' }) protected dispatchFacebookLogout: any;

  @Action('GOOGLE_INIT_AUTH_INSTANCE', { namespace: 'auth' }) protected dispatchGoogleInitAuthInstance: any;

  @Action('GOOGLE_LOGIN', { namespace: 'auth' }) protected dispatchGoogleLogin: any;

  @Action('GOOGLE_LOGOUT', { namespace: 'auth' }) protected dispatchGoogleLogout: any;

  @Action('APP_GOOGLE_LOGIN', { namespace: 'auth' }) protected dispatchAppGoogleLogin: any;

  @Action('APP_FACEBOOK_LOGIN', { namespace: 'auth' }) protected dispatchAppFacebookLogin: any;

  @Action('LOGOUT', { namespace: 'auth' }) protected dispatchLogout: any;

  @Action('CONFIRMED_LOGIN', { namespace: 'auth' }) protected dispatchConfirmedLogin: any;

  @Action('FACEBOOK_INIT_SDK', { namespace: 'auth' }) protected dispatchFacebookInitSDK: any;

  @Getter('isAuthenticated', { namespace: 'auth' }) protected isAuthenticated?: boolean;

  @Getter('isGoogleAuthenticated', { namespace: 'auth' }) protected isGoogleAuthenticated?: boolean;

  @Getter('isFacebookAuthenticated', { namespace: 'auth' }) protected isFacebookAuthenticated?: boolean;

  @Getter('GET_FACEBOOK_SDK', { namespace: 'auth' }) protected sdk?: object;

  @Getter('isSocialProviderSending', { namespace: 'auth' }) protected isSocialProviderSending?: boolean;

  @Action('SET_FACEBOOK_SDK', { namespace: 'auth' }) protected dispatchSetFacebookSDK: any;

  @Prop({ default: false, type: Boolean }) protected isSignUp?: boolean;

  public currentSocialProvider:string = '';

  public showTermsDialogSync:boolean = false;

  protected async onFacebookClick() {
    this.currentSocialProvider = 'facebook';
    if (!this.isFacebookAuthenticated) {
      await this.dispatchFacebookInitSDK();
      const { plan } = this.$route.query;
      const facebookParams: any = {};
      if (plan) {
        facebookParams.subscriptionPlan = plan;
      }
      await this.dispatchFacebookLogin(facebookParams);
      if (!this.isSignUp) {
        await this.dispatchAppFacebookLogin();
      }
    } else {
      this.dispatchFacebookLogout();
    }
    this.$emit('click');
  }

  @Watch('showTermsDialog')
  onShowTermsDialog(value:boolean) {
    this.showTermsDialogSync = value;
  }

  public async mounted() {
    this.dispatchGoogleInitAuthInstance();
  }

  protected async onGoogleClick() {
    this.currentSocialProvider = 'google';
    if (this.isGoogleAuthenticated) {
      this.dispatchGoogleLogout();
    } else {
      const { plan } = this.$route.query;
      const googleParams: any = {};
      if (plan) {
        googleParams.subscriptionPlan = plan;
      }
      await this.dispatchGoogleLogin(googleParams);
      if (!this.isSignUp) {
        this.dispatchAppGoogleLogin();
      }
    }
  }

  protected async onSocialSignUp() {
    await this.dispatchConfirmedLogin(this.currentSocialProvider);
    if (!this.isSignUp) {
      switch (this.currentSocialProvider) {
        case 'google':
          this.dispatchAppGoogleLogin();
          break;
        case 'facebook':
          this.dispatchAppFacebookLogin();
          break;
        default:
          break;
      }
    }
  }
}

